import type { RouteRecordRaw } from 'vue-router'
import { ADMIN_RBAC_PERMISSIONS } from '@/config/admin/rbac'

export const adminOpsRoutes: RouteRecordRaw[] = [
  {
    path: 'ops/dashboard',
    name: 'AdminOpsDashboard',
    component: () => import('@/views/admin/ops/AdminOpsDashboardPage.vue'),
    meta: {
      title: '运营仪表盘',
      sidebarId: 'ops-dashboard',
      permissions: [ADMIN_RBAC_PERMISSIONS.OPS_DASHBOARD_VIEW],
      breadcrumb: true,
      cache: true,
    },
  },
  {
    path: 'ops/monitor',
    name: 'AdminSystemMonitor',
    component: () => import('@/views/admin/ops/AdminSystemMonitorPage.vue'),
    meta: {
      title: '系统监控',
      sidebarId: 'system-monitor',
      permissions: [ADMIN_RBAC_PERMISSIONS.OPS_MONITOR_VIEW],
      breadcrumb: true,
      cache: true,
    },
  },
]
